<div class="container-fluid" [ngSwitch]="settingsLoaded | async">
  <div *ngSwitchCase="true">
    <router-outlet></router-outlet>
  </div>
  <div *ngSwitchCase="false">
    <hlu-spinner></hlu-spinner>
  </div>
</div>
<footer class="footer fixed-bottom text-center">
  <div class="container">
    <small class="text-muted"
      >&copy; 2016 - {{ currentYear }}, The Mezzanine Floor Group Ltd. All
      rights reserved.
      <a routerLink="/terms-of-use">Terms of Use</a>
    </small>
  </div>
</footer>
